export var BottomMessageToken;
(function (BottomMessageToken) {
    BottomMessageToken["Limit"] = "{limit}";
    BottomMessageToken["Number"] = "{number}";
})(BottomMessageToken || (BottomMessageToken = {}));
